"use strict";

var _defineProperty = require("/codebuild/output/src1656618240/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _internal = require("../../theme/internal"); // ============================== Shared ==============================


var genSharedAffixStyle = function genSharedAffixStyle(token) {
  var componentCls = token.componentCls;
  return _defineProperty({}, componentCls, {
    position: 'fixed',
    zIndex: token.zIndexPopup
  });
}; // ============================== Export ==============================


var _default = (0, _internal.genComponentStyleHook)('Affix', function (token) {
  var affixToken = (0, _internal.mergeToken)(token, {
    zIndexPopup: token.zIndexBase + 10
  });
  return [genSharedAffixStyle(affixToken)];
});

exports.default = _default;